import gql from 'graphql-tag';
export const GET_USER_APPS = gql `
  query UserAppsQuery($userId: UUID!) {
    userApps(userId: $userId) {
      id
      name
      description
      orderIndex
      url
      icon
      active
      thirdParty
      isPreferred
    }
  }
`;
//# sourceMappingURL=apps.list.js.map